
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38 38"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 298","cx":"18.999","cy":"18.999","r":"18.999","fill":"none"}}),_c('g',{attrs:{"data-name":"twitter"}},[_c('path',{attrs:{"data-name":"Path 2780","d":"M31.838 11.423a9.566 9.566 0 01-2.748.756 4.81 4.81 0 002.109-2.651 9.6 9.6 0 01-3.044 1.162 4.8 4.8 0 00-8.17 4.373 13.609 13.609 0 01-9.882-5.01 4.8 4.8 0 001.489 6.4 4.76 4.76 0 01-2.176-.6v.06a4.8 4.8 0 003.846 4.7 4.81 4.81 0 01-2.165.086 4.8 4.8 0 004.479 3.329 9.678 9.678 0 01-7.1 1.986 13.63 13.63 0 0020.985-11.48c0-.207 0-.415-.014-.62a9.722 9.722 0 002.393-2.481z","fill":"#fff"}})])])
          )
        }
      }
    